// src/redux/slices/planSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchPlanFeatures } from '../thunks/planThunks';

const initialState = {
  features: {},     // { FEATURE_CODE: { type, value, label }, ... }
  planName: '',
  planCode: '',
  orgFullName: '',
  isTrial: false,
  trialEndDate: null,
  validUntil: null,
  billingCycle: null,
  subscriptionStatus: null,
  billingEndDate: null,
  loading: false,
  error: null,
  currentPlanTier: '',
  upgradeDialogOpen: false,
  upgradeDialogRequiredPlan: null,
  upgradeDialogFeatureLabel: null,
  upgradeDialogFeatureType: null,
  upgradeDialogLimitValue: null,
};

const planSlice = createSlice({
  name: 'plan',
  initialState,
  reducers: {
    clearPlanFeatures: () => initialState,
    openUpgradeDialog: (state, action) => {
      state.upgradeDialogOpen = true;
      state.upgradeDialogRequiredPlan = action.payload.requiredPlan;
      state.upgradeDialogFeatureLabel = action.payload.featureLabel;
      state.upgradeDialogFeatureType = action.payload.featureType || null;
      state.upgradeDialogLimitValue = action.payload.limitValue || null;
    },
    closeUpgradeDialog: (state) => {
      state.upgradeDialogOpen = false;
      state.upgradeDialogRequiredPlan = null;
      state.upgradeDialogFeatureLabel = null;
      state.upgradeDialogFeatureType = null;
      state.upgradeDialogLimitValue = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlanFeatures.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlanFeatures.fulfilled, (state, action) => {
        state.loading = false;
        state.features = action.payload.features || {};
        state.planName = action.payload.planName || '';
        state.planCode = action.payload.planCode || '';
        state.orgFullName = action.payload.orgFullName || '';
        state.isTrial = action.payload.trial || false;
        state.trialEndDate = action.payload.trialEndDate || null;
        state.validUntil = action.payload.validUntil || null;
        state.billingCycle = action.payload.billingCycle || null;
        state.subscriptionStatus = action.payload.subscriptionStatus || null;
        state.billingEndDate = action.payload.billingEndDate || null;
        state.currentPlanTier = action.payload.currentPlanTier || '';
      })
      .addCase(fetchPlanFeatures.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch plan features';
      });
  },
});

export const { clearPlanFeatures, openUpgradeDialog, closeUpgradeDialog } = planSlice.actions;
export default planSlice.reducer;
